import api from '@/services/api';
import type { MotHistoryResponse } from '../types/motHistory.types';

export const fetchMotHistory = async (params: {
  vin?: string;
  vrm?: string;
}): Promise<MotHistoryResponse> => {
  const response = await api.post('/vehicles/mot-history', params);
  return response.data.data as MotHistoryResponse;
};
